import React from "react";
import PageLayout from "../UI/PageLayout";
import ContentForPage from "../../containers/ContentForPage";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";

const AIHealthPage = () => {
  return (
    <PageLayout
      title="AI Health"
      dropdowns={
        <GenericReportingDropdowns
          includeDateRange={true}
          includeGranularity={true}
          includeTooltipsAndTitles={false}
          containerStyle="dropdown-container"
          renderAsButton={true}
          includeCompareDateRange={true}
          includeSingleSelectRegion={true}
          includeRegion={false}
        />
      }
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <ContentForPage pageName={"ai_health"} />
        </div>
      }
    />
  );
};

export default AIHealthPage;


